import field from '@/_oad_repo/mixins/field'

export default field